import React, { PureComponent } from 'react';
import errorBoundary from '@ifeng-fe/errorBoundary';
import PropTypes from 'prop-types';
// import queryString from 'query-string';
import auth from '@ifeng-fe/ui_pc_auth';
import styles from './index.css';
import TopRank from './topRank';
import Pagination from './pagination/';
import CommentsList from './commentsList/';
import { getUserComments, getGuid } from '../../../../services/api.js';

/**
 * 解析地址栏参数
 */
const queryString = () => {
    const result = {};
    const params = window.location.search.substring(1).split('&');
    let param = '';

    params.forEach(item => {
        param = item.split('=');
        if (param.length === 2) {
            result[param[0]] = decodeURIComponent(param[1]);
        }
    });

    return result;
};

class MainContent extends PureComponent {
    static propTypes = {
        loginId: PropTypes.string,
    };
    constructor(props) {
        super(props);

        const parsed = queryString();

        this.state = {
            guid: parsed.guid || '',
            selfGuid: '',
            current: 1,
            count: 0,
            commentsList: [],
            userInfo: auth.isLogin() ? auth.getUserInfo() : {},
            myComUrl: '',
        };
    }

    handlePageClick = async clickPage => {
        const { guid } = this.state;

        if (guid) {
            const userCommentsData = await getUserComments(guid, clickPage, 20);

            if (userCommentsData) {
                this.setState({
                    commentsList: userCommentsData.comments || [],
                });
            }
        }
    };

    async componentDidMount() {
        const { guid, userInfo: { sid } = {} } = this.state;

        this.unBindLogin = auth.event.on(auth.EVENTNAMES.login, userInfo => {
            this.setState({
                userInfo,
            });
        });
        this.unBindLogout = auth.event.on(auth.EVENTNAMES.logout, () => {
            this.setState({
                userInfo: {},
            });
        });

        if (guid) {
            const userCommentsData = await getUserComments(guid, 1, 20);

            if (userCommentsData) {
                this.setState({
                    count: userCommentsData.count || 0,
                    commentsList: userCommentsData.comments || [],
                });
            }
        }

        if (sid) {
            const data = await getGuid(sid);

            if (data.data && data.data.guid) {
                const selfGuid = data.data.guid;
                const myComUrl = `${location.origin}/myComments?guid=${selfGuid}`;

                this.setState({
                    selfGuid,
                    myComUrl,
                });
            }
        }
    }

    componentWillUnmount() {
        this.unBindLogin();
        this.unBindLogout();
    }

    render() {
        const { count, commentsList, userInfo, myComUrl } = this.state;
        const { loginId } = this.props;

        return (
            <div className={styles.mainContent}>
                <div className={styles.topMyInfo}>
                    <img src="//y0.ifengimg.com/vusercenter/images/default_user_pic.gif" alt="用户头像" />
                </div>
                <div className={styles.commentPage}>
                    <div className={styles.commentLeft}>
                        <CommentsList
                            content={commentsList}
                            userInfo={userInfo}
                            myComUrl={myComUrl}
                            loginId={loginId}
                        />
                        {count > 0 ? (
                            <Pagination total={count} pageSize={20} handleClick={this.handlePageClick} />
                        ) : null}
                    </div>
                    <div className={styles.commentRight}>
                        <TopRank />
                    </div>
                    <div className="clearfix" />
                </div>
            </div>
        );
    }
}

export default errorBoundary(MainContent);
